/**
 * Group an array by a selector and return a map.
 *
 * @param arr - The array to group
 * @param groupingFunc - The grouping function
 * @returns the map of grouped items
 */
export function groupArrayToMap<T, Group>(arr: T[], groupingFunc: (item: T) => Group): Map<Group, T[]> {
    const groupedMap = new Map<Group, T[]>();

    for (const item of arr) {
        const group = groupingFunc(item);
        const newArr = groupedMap.get(group) ?? [];
        newArr.push(item);
        groupedMap.set(group, newArr);
    }
    return groupedMap;
}
